import { SettingsMap } from "../../types/webchatTabsTypes";

export const hasValue = (v: unknown) =>
  v !== null && v !== undefined && !(typeof v === 'string' && v.trim() === '');

export const normalizeResponse = (raw: unknown): SettingsMap => {
  if (Array.isArray(raw)) {
    const mapped: SettingsMap = {};
    for (const item of raw) {
      if (!item || typeof item !== 'object') continue;
      const rec = item as Record<string, unknown>;
      const key = typeof rec.key === 'string' ? rec.key : '';
      if (!key) continue;
      mapped[key] = {
        value: (rec.value as string | number) ?? '',
        default: (rec.default as string | number) ?? (rec.defaultValue as string | number) ?? '',
        isSensitive: typeof rec.isSensitive === 'boolean' ? rec.isSensitive : undefined,
      };
    }
    return mapped;
  }
  if (raw && typeof raw === 'object') {
    const container = raw as Record<string, unknown>;
    if (Array.isArray(container.settings)) return normalizeResponse(container.settings);
    if (Array.isArray(container.data)) return normalizeResponse(container.data);
  }
  if (raw && typeof raw === 'object') {
    const obj = raw as Record<string, unknown>;
    const mapped: SettingsMap = {};
    for (const [key, val] of Object.entries(obj)) {
      if (!val || typeof val !== 'object') continue;
      const rec = val as Record<string, unknown>;
      mapped[key] = {
        value: (rec.value as string | number) ?? '',
        default: (rec.default as string | number) ?? (rec.defaultValue as string | number) ?? '',
        isSensitive: typeof rec.isSensitive === 'boolean' ? rec.isSensitive : undefined,
      };
    }
    return mapped;
  }
  return {};
}

